import type { RouteRecordRaw } from 'vue-router';

import { useUserStore } from '@/stores/user.store';

export const trainingRoutes: Array<RouteRecordRaw> = [
  {
    name: 'Training',
    path: 'training',
    children: [
      {
        name: 'TrainingDashboard',
        path: 'dashboard',
        component: () =>
          import('@/views/private/training/TrainingDashboard.vue'),
      },
      {
        name: 'TrainingRoleplay',
        path: 'roleplay',
        component: () =>
          import('@/views/private/training/TrainingRoleplay.vue'),
      },
      {
        name: 'TrainingUserIndicatorRedirect',
        path: 'person',
        redirect: () => {
          const userStore = useUserStore();
          const personId = userStore.profile?.person?.id;
          if (personId) {
            return {
              name: 'TrainingUserIndicator',
              params: { personId },
            };
          }
          return { name: 'TrainingDashboard' };
        },
      },
      {
        name: 'TrainingUserIndicator',
        path: 'person/:personId',
        props: true,
        component: () =>
          import('@/views/private/training/TrainingUserIndicator.vue'),
      },
      {
        name: 'TrainingChat',
        path: 'chat/:roleplayId',
        props: true,
        component: () => import('@/views/private/training/TrainingChat.vue'),
      },
      {
        name: 'TrainingChatHistory',
        path: 'chat/:chatId/history',
        props: true,
        component: () =>
          import('@/views/private/training/TrainingChatHistory.vue'),
      },
    ],
  },
];
